import angular from 'angular';
import invoiceCreateOtherComponent from './invoice-create-other.component';

let invoiceCreateOtherModule = angular.module('invoiceCreateOther', [])
  .component('invoiceCreateOther', invoiceCreateOtherComponent);

export default invoiceCreateOtherModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-other/invoice-create-other.js